export enum HTTPRequestMethods {
    GET = 'GET',
    POST = 'POST',
}
export const HeaderContentType = {
    JSON: 'application/json',
    IMG_PNG: 'image/png',
    URLENCODED: 'application/x-www-form-urlencoded',
  }
  